import { User } from '@townsquare/user-store';

import { ScreenType } from '../config/ScreenConfig';

const SHOW_EMPTY_TEAMS_KEY = 'showEmptyTeams';
export const appendEmptyTeamSearchToTql = (tql: string): string => {
  if (tql.includes(SHOW_EMPTY_TEAMS_KEY)) {
    return tql;
  }
  return `${tql.length > 0 ? `(${tql}) AND ` : ''}(${SHOW_EMPTY_TEAMS_KEY} = true)`;
};

export const updateTeamQueryBasedOnScreen = (tql: string, screen: ScreenType, user: User) => {
  if (screen === 'YOUR_TEAMS' || screen === 'BROWSE_ALL') {
    const memberQuery = `(member = ${user.accountId})`;
    return tql ? `${tql} AND ${memberQuery}` : memberQuery;
  }
  return tql;
};
